import * as Types from '../../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type AssignUserToStepMutationVariables = Types.Exact<{
  input: Types.AssignUserToStepInput
}>

export type AssignUserToStepMutation = {
  __typename?: 'Mutation'
  assignUserToOnboardingStep?: {
    __typename?: 'AssignUserToStepPayload'
    onboardingStep?: {
      __typename?: 'OnboardingStep'
      id: number
      stepType: Types.OnboardingStepType
      status: Types.OnboardingStatus
      assignee: {
        __typename?: 'User'
        id: number
        firstName?: string | null
        lastName?: string | null
        email?: string | null
      }
    } | null
    user?: {
      __typename?: 'User'
      id: number
      firstName?: string | null
      lastName?: string | null
      email?: string | null
    } | null
    organization?: {
      __typename?: 'Organization'
      id: number
      onboardingWorkflow?: {
        __typename?: 'OnboardingWorkflow'
        id: number
        status: Types.OnboardingStatus
        steps: Array<{
          __typename?: 'OnboardingStep'
          id: number
          stepType: Types.OnboardingStepType
          status: Types.OnboardingStatus
          assignee: {
            __typename?: 'User'
            id: number
            firstName?: string | null
            lastName?: string | null
            email?: string | null
          }
        }>
      } | null
    } | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const AssignUserToStepDocument = `
    mutation AssignUserToStep($input: AssignUserToStepInput!) {
  assignUserToOnboardingStep(input: $input) {
    onboardingStep {
      id
      stepType
      status
      assignee {
        id
        firstName
        lastName
        email
      }
    }
    user {
      id
      firstName
      lastName
      email
    }
    organization {
      id
      onboardingWorkflow {
        id
        status
        steps {
          id
          stepType
          status
          assignee {
            id
            firstName
            lastName
            email
          }
        }
      }
    }
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useAssignUserToStepMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<AssignUserToStepMutation, TError, AssignUserToStepMutationVariables, TContext>
) =>
  useMutation<AssignUserToStepMutation, TError, AssignUserToStepMutationVariables, TContext>(
    ['AssignUserToStep'],
    (variables?: AssignUserToStepMutationVariables) =>
      fetchGql<AssignUserToStepMutation, AssignUserToStepMutationVariables>(
        AssignUserToStepDocument,
        variables
      )(),
    options
  )
